enum Urls {
    baseApiUrl = "https://api.woosmap.com",
    mapJS = "https://sdk.woosmap.com/map/map.js",
    localitiesWidgetJS = "https://sdk.woosmap.com/localities/localitieswidget.2.0.js",
    localitiesWidgetCSS = "https://sdk.woosmap.com/localities/style.2.0.css",
}

export default Urls;
